import React from 'react';
import Styled from 'styled';
import { Link, Route, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Helmet from 'helmet/helmet';

import SVGIconView from 'lib/images/svg-icon-view';
import { Halfpage, ZoznamHalfpageTop } from 'lib/google/dfp/ad-units/halfpage';
import RouteWithSearch from 'lib/react-router/route-with-search';

import IconAddToGroup from 'four-nets/icons/svg/icon_add-to-group.svg';
import LeftMenu from 'four-nets/photoblog/left-menu/left-menu';
import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import Unauthorized from 'four-nets/errors/401/unauthorized';
import { Site } from 'four-nets/site';

import MyGroups from './my-groups/my-groups';
import NewGroups from './new-groups/new-groups';
import AllGroups from './all-groups/all-groups';

import defaultStyles from './groups.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class Groups extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    renderHelmet = (H: React.ComponentClass) => {
        const { site } = this.context;

        return (
            <FormattedMessage id='GROUP_LIST'>
                {message => (
                    <H>
                        <title>
                            {message} | {site.name}
                        </title>
                    </H>
                )}
            </FormattedMessage>
        );
    };

    render() {
        const { styles } = this.props;
        const { site } = this.context;

        return (
            <React.Fragment>
                <Helmet render={this.renderHelmet} />
                <div className={styles.topContainer}>
                    <h1 className={styles.title}>
                        <Switch>
                            <Route
                                path='/list-of-groups/mine'
                                render={() => <FormattedMessage id='GROUPS_MY_GROUPS' />}
                            />
                            <Route path='/list-of-groups' render={() => <FormattedMessage id='GROUP_LIST' />} />
                        </Switch>
                    </h1>
                    <Link to='/new-group/' className={styles.addToGroupLink}>
                        <SVGIconView className={styles.buttonImage} src={IconAddToGroup} />
                        <FormattedMessage id='GROUPS_CREATE_NEW_GROUP' />
                    </Link>
                </div>
                <div className={styles.container}>
                    <LeftMenu />
                    <div className={styles.groups}>
                        <Switch>
                            <Route
                                path='/list-of-groups/mine'
                                render={() => (
                                    <ViewerConsumer>
                                        {({ viewer }) => (viewer ? <MyGroups all={true} /> : <Unauthorized />)}
                                    </ViewerConsumer>
                                )}
                            />
                            <RouteWithSearch
                                path='/list-of-groups'
                                render={props => (
                                    <React.Fragment>
                                        <MyGroups />
                                        <NewGroups />
                                        <AllGroups {...props} />
                                    </React.Fragment>
                                )}
                            />
                        </Switch>
                        {site.isSlovak && site.isWedding ? (
                            <ZoznamHalfpageTop
                                sizeMapping={[
                                    [
                                        [0, 0],
                                        ['fluid', [300, 600], [300, 300]],
                                    ],
                                    [[1024, 0], []],
                                ]}
                            />
                        ) : (
                            <Halfpage
                                sizeMapping={[
                                    [
                                        [0, 0],
                                        ['fluid', [300, 600], [300, 300]],
                                    ],
                                    [[1024, 0], []],
                                ]}
                                adUnitCode='halfpage-top'
                            />
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(Groups as any);
